import { useState, useEffect } from "react";

import Alert from "react-bootstrap/Alert";

const alertTimeout = 5000;

export default function MyAlert (props)
{
    const [show, setShow] = useState(true);

    useEffect(() => { setTimeout(() => { handleClose() }, alertTimeout); }, []);
    
    function handleClose ()
    {
	setShow(false);
    }
    
    return (
	<Alert show={show} variant={props.variant} className="me-3 mb-3" style={{ width: 640 }} dismissible onClose={handleClose}>
	    <Alert.Heading className="fs-5">{props.title}</Alert.Heading>
	    <p>{props.content}</p>
	</Alert>
    );
}
